import type { LeaveTypesRepositoryT } from "screens/Vacations/components/LeaveTypes/domain/ports/leaveTypes.repository";
import type { UpdateLeaveTypeTypeFormValuesT } from "screens/Vacations/components/LeaveTypes/domain/types/leaveType.types";

import type { PolicyRepositoryT } from "shared/domain/ports/policy.repository";
import type { VacationPolicyFormValuesT } from "shared/domain/types/policy.types";
import type { PolicyEntityT } from "shared/domain/entities/policy.entity";

type UpdateVacationPolicyParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  policyRepository: PolicyRepositoryT;
  type: UpdateLeaveTypeTypeFormValuesT;
  policy: VacationPolicyFormValuesT;
  colaboraInstanceId: string;
  policyId: string;
};

export const updateVacationPolicy = async ({
  leaveTypesRepository,
  policyRepository,
  type,
  policy,
  colaboraInstanceId,
  policyId,
}: UpdateVacationPolicyParamsT): Promise<PolicyEntityT> => {
  const { failed } = await leaveTypesRepository.update(
    type,
    colaboraInstanceId,
    "VACATION",
  );

  if (failed.length > 0) {
    throw new Error(failed[0].reason);
  }

  return await policyRepository.updateVacationPolicy(
    policy,
    colaboraInstanceId,
    policyId,
  );
};
